import { useModal } from "contexts/ModalContext";
import { useTranslations } from "contexts/LocalizationContext";
import FlagBox from "components/LanguageSwitcher/FlagBox";
import { useFlagBoxSettings } from "contexts/SettingsContext";
import { ChakraFlex as Flex, ChakraText as Text } from "@airhelp/react-ui-components";

const FOOTER_LANG_MODAL_OPEN_EVENT_UA = ["clicked", "Footer", "OpenModal"] as const;
const FOOTER_LANG_MODAL_OPEN_EVENT = { event: "cta_click", label: "open_modal", placement: "Footer" } as const;

const Copyright = () => {
  const translations = useTranslations();
  const { openModal } = useModal();
  const hideFlagBox = useFlagBoxSettings();

  return (
    <Flex justifyContent={hideFlagBox ? "flex-end" : "space-between"} alignItems="center">
      {!hideFlagBox && <FlagBox openModal={openModal} gaEvent={FOOTER_LANG_MODAL_OPEN_EVENT} uaEvent={FOOTER_LANG_MODAL_OPEN_EVENT_UA} />}
      <Text color="greyscale.500" fontSize="md">
        {translations("menu_copyright", { "%current-year%": new Date().getFullYear() })}
      </Text>
    </Flex>
  );
};

export default Copyright;
